import {gql} from "@apollo/client";

export const GET_USER_DOCUMENTS = gql`
          query GetUserDocuments{
              documents {
                identityDocument {
                  id
                  verificationStatus
                  value
                }
                addressDocument {
                  id
                  verificationStatus
                  value
                }
            
                solvencyDocument {
                  id
                  verificationStatus
                  value
                }
                paymentMethodsDocuments
                {
                  id
                  verificationStatus
                  value
                }
                bankAccountDocuments
                {
                  id
                  verificationStatus
                  value
                }
                walletDocuments
                {
                  id
                  verificationStatus
                  value
                }
              }
            }
          `;